import axios from 'axios';

import Config from '../../config';

import { AUTH_API } from '../auth/actions';

import { CLIENT_UPDATE } from './actions';

axios.defaults.headers.common['Content-Type'] = 'application/json;charset=UTF-8';

export const api_confirm_client = (data) => {
    return (dispatch) => {

        return axios.post(`${Config.API_BASE_URL}/client/confirm`, data)
            .then(response => {

                const email = response.data.email;
                const password = response.data.password;

                delete response.data['password'];

                dispatch({
                    type: CLIENT_UPDATE,
                    payload: response.data
                });

                dispatch(AUTH_API.login({ email: email, password: password }));
            })
            .catch(error => {

                dispatch({
                    type: CLIENT_UPDATE,
                    payload: {
                        errors: error.response.data
                    }
                });
            });
    };
}
export default api_confirm_client;